import { CheckCircleOutlined, SyncOutlined } from "@ant-design/icons";
import { Drawer, List, Space, Tag, Typography } from "antd";
import { useHandleSubmitApi } from "hook";
import { IDetailChangeRevisionOutputModel, IGetDetailInventoryOutputModel, TRevisionOutputModel } from "interfaces";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { InventoryServices } from "services/inventory";
import HistoryTableInventoryForm from "../HistoryTableInventoryForm/HistoryTableInventoryForm.presenter";

export interface IHistoryPostFormProps {
  onClose: () => void;
  id: string | null;
}

export default function HistoryInventoryForm(props: IHistoryPostFormProps) {
  const { Text } = Typography;
  const [data, setData] = useState<TRevisionOutputModel<IGetDetailInventoryOutputModel>[]>([]);
  const [dataRevision, setDataRevision] = useState<IDetailChangeRevisionOutputModel[]>([]);
  const [revisionId, setVisionId] = useState<string | null>(null);
  const [version, setVersion] = useState(-1);

  useEffect(() => {
    if (!props.id) return;
    getListHistory(props.id);
  }, [props.id]);

  useEffect(() => {
    if (!revisionId || !props.id) return;
    getDiffRevision(revisionId);
  }, [revisionId]);

  const [getListHistory, loadingGetHistory] = useHandleSubmitApi(async (inventoryId: string) => {
    const dataRes = await InventoryServices.getListInventoryRevision(inventoryId);
    if (dataRes) {
      setData(_.orderBy(dataRes?.data || [], ["version"], ["desc"]));
    }
  });

  const [getDiffRevision] = useHandleSubmitApi(async (revisionId: string) => {
    const dataRes = await InventoryServices.getDiffInventoryPost(revisionId);
    if (dataRes) {
      if (!!dataRes.data) {
        setDataRevision(dataRes.data);
      }
    }
  });

  return (
    <>
      {
        <HistoryTableInventoryForm
          data={{
            changeVersion: {
              currentVersion: version.toString(),
              prevVersion: (version - 1).toString(),
            },
            list: dataRevision,
          }}
          onClose={() => {
            setVisionId(null);
            setDataRevision([]);
          }}
        />
      }

      <Drawer title="Lịch sử thay đổi" onClose={props.onClose} open={!!props.id}>
        <List
          dataSource={data}
          loading={loadingGetHistory}
          renderItem={(revision) => (
            <List.Item
              key={revision.id}
              onClick={() => {
                setVisionId(revision.id);
                setVersion(revision.version);
              }}
              style={{ cursor: "pointer" }}
            >
              <List.Item.Meta
                title={
                  <div className="d-flex items-center justify-space-between">
                    <span className="mr_1">{`Version ${revision.version}`}</span>
                    {revision.version === 1 ? (
                      <Tag icon={<CheckCircleOutlined />} color="success">
                        Tạo mới
                      </Tag>
                    ) : (
                      <Tag icon={<SyncOutlined spin />} color="processing">
                        Cập nhật
                      </Tag>
                    )}
                  </div>
                }
                description={
                  <Space direction="vertical">
                    <Text>{moment(revision.createdAt).format("DD/MM/YYYY HH:mm:ss")}</Text>
                    <Text>
                      Cập nhật: <b>{revision.changeBy?.lastName + " " + revision.changeBy.firstName}</b>
                    </Text>
                  </Space>
                }
              />
            </List.Item>
          )}
        />
      </Drawer>
    </>
  );
}
